import type { InvivoMaterialPlan } from "../../types/invivo_scene";
import { createLegacyNodeMaterial } from "./create_legacy_node_material";
import { createSheetMaterial } from "./create_sheet_material";
import { createStandardPbrMaterial } from "./create_standard_pbr_material";
import { LEGACY_VIEWER_NODE_MATERIALS } from "./legacy_node_materials";

export function createInvivoMaterial({
  scene,
  materialPlan,
}: {
  scene: unknown;
  materialPlan: InvivoMaterialPlan;
}): unknown {
  if (materialPlan.kind === "standard_pbr") {
    return createStandardPbrMaterial({ scene, materialPlan });
  }

  if (materialPlan.kind === "sheet") {
    return createSheetMaterial({ scene, materialPlan });
  }

  const serializedMaterial = LEGACY_VIEWER_NODE_MATERIALS[
    materialPlan.program as keyof typeof LEGACY_VIEWER_NODE_MATERIALS
  ] as Record<string, unknown> | undefined;

  if (!serializedMaterial) {
    throw new Error(`Unknown legacy node material program "${materialPlan.program}".`);
  }

  return createLegacyNodeMaterial({
    scene,
    serializedMaterial,
    materialName: `Invivo::legacy_node::${materialPlan.name}`,
    backFaceCulling: materialPlan.backFaceCulling,
    alpha: materialPlan.alpha,
    transparencyMode: materialPlan.transparencyMode,
    nodeMaterialInputs: materialPlan.nodeMaterialInputs,
    textureBindings: materialPlan.textureBindings,
  });
}
